<template>
    <pre class="connection-test" :class="status" v-if="visible">{{ current }}</pre>
</template>

<script>
export default {
    name: 'ConnectionTest',

    data: function () {
        return {
            visible: false,
            status: 'idle',
            current: '',
            runId: 0,
            timers: [],
            guard: null,
            controller: null,
        }
    },

    methods: {
        start(did) {
            if (!did) { return }

            this.cancel()
            this.runId += 1

            const run = this.runId
            const startedAt = Date.now()

            this.visible = true
            this.status = 'testing'
            this.current = 'ATDT ' + did
            this.controller = new AbortController()

            this.addTimer(() => { this.setStep(run, 'DIALING...') }, 200)
            this.addTimer(() => { this.setStep(run, 'HANDSHAKE ░▒▓█▓▒░') }, 600)
            this.addTimer(() => { this.setStep(run, 'PING > OC > WR') }, 1000)

            this.guard = setTimeout(() => {
                if (run === this.runId && this.controller) { this.controller.abort() }
            }, 6500)

            this.request(did, run, startedAt)
        },

        async request(did, run, startedAt) {
            let connected = false
            let latency = null

            try {
                const response = await window.afetch(`/ping?did=${encodeURIComponent(did)}`, {
                    signal: this.controller.signal
                })
                const data = await response.json()

                connected = response.ok && data.connected === true
                latency = data.latency
            } catch (e) {
                connected = false
            }

            if (run !== this.runId) { return }

            if (this.guard) {
                clearTimeout(this.guard)
                this.guard = null
            }

            const wait = Math.max(0, 1300 - (Date.now() - startedAt))

            this.addTimer(() => { this.finish(run, connected, latency) }, wait)
        },

        finish(run, connected, latency) {
            if (run !== this.runId) { return }

            if (connected) {
                this.status = 'success'
                this.current = `CLIENT CONNECTED ${latency || 0}ms`
            } else {
                this.status = 'fail'
                this.current = 'CLIENT UNREACHABLE'
            }
        },

        setStep(run, line) {
            if (run !== this.runId) { return }
            this.current = line
        },

        addTimer(fn, ms) {
            this.timers.push(setTimeout(fn, ms))
        },

        cancel() {
            this.timers.forEach((timer) => { clearTimeout(timer) })
            this.timers = []

            if (this.guard) {
                clearTimeout(this.guard)
                this.guard = null
            }

            if (this.controller) {
                this.controller.abort()
                this.controller = null
            }
        },

        clear() {
            this.cancel()
            this.runId += 1
            this.visible = false
            this.status = 'idle'
            this.current = ''
        },
    },

    beforeDestroy() {
        this.clear()
    },
}
</script>

<style scoped lang="scss">
.connection-test {
    margin: 0;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 6px;
    padding-top: 10px;
    display: flex;
    letter-spacing: 1px;
    white-space: pre-wrap;
    color: white;

    &.success {
        color: #8dff8d;
    }

    &.fail {
        color: #ff8a65;
    }
}
</style>
